/* Pestocart product template | assets/pestocart-pdp.js */
(function(){
"use strict";
var root=document.querySelector('[data-pc]'); if(!root) return;

var ICON={
 'Why choose it':'M12 2l2.4 6.9L21 9.6l-5 4.5 1.4 6.6L12 17.4 6.6 20.7 8 14.1 3 9.6l6.6-.7z',
 'Ideal for':'M3 10l9-7 9 7v10a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2zM9 22V12h6v10',
 'How to use':'M8 6h13M8 12h13M8 18h13M3 6h.01M3 12h.01M3 18h.01',
 'Safety':'M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10zM12 8v4M12 16h.01',
 'First aid':'M2 6h20v14H2zM9 6V4h6v2M12 10v6M9 13h6',
 'Tips':'M9 18h6M10 22h4M12 2a6 6 0 0 1 4 10.5c-.6.6-1 1.4-1 2.2V16H9v-1.3c0-.8-.4-1.6-1-2.2A6 6 0 0 1 12 2z',
 "What's included":'M21 8l-9-5-9 5 9 5zM3 8v8l9 5 9-5V8M12 13v8',
 'Details':'M3 3h18v18H3zM7 8h10M7 12h10M7 16h6'
};
var DEF='M3 3h18v18H3zM7 8h10M7 12h10M7 16h6';
var ORDER=['Why choose it','Ideal for','How to use','Tips',"What's included",'Details','Safety','First aid'];
var CARE={'Safety':1,'First aid':1};
var CANON=[
 ['First aid',['first aid']],
 ['Safety',['safety','precaution','warning','hazard']],
 ['How to use',['how to use','direction','application','how to apply','before fumigation','after fumigation']],
 ['Ideal for',['ideal for','where to use','suitable','recommended use','best for']],
 ['Why choose it',['why','benefit','key feature','product feature','features','what makes']],
 ['Tips',['tip','best practice','note']],
 ["What's included",["what's in",'what s in','combo includes','in the combo','pack includes','contents']],
 ['Details',['product detail','specification','technical']]
];
function canon(h){
  var t=h.toLowerCase().replace(/&amp;/g,'and').replace(/&/g,' and ').replace(/[^a-z ]/g,' ').replace(/\s+/g,' ').trim();
  for(var i=0;i<CANON.length;i++){var keys=CANON[i][1];
    for(var j=0;j<keys.length;j++){if(t.indexOf(keys[j])>-1)return CANON[i][0]}}
  return null;
}
function svg(d,s){return '<svg viewBox="0 0 24 24" width="'+(s||14)+'" height="'+(s||14)+'" fill="none" stroke="currentColor" stroke-width="1.9" stroke-linecap="round" stroke-linejoin="round"><path d="'+d+'"/></svg>'}
function tick(){return '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="3" stroke-linecap="round" stroke-linejoin="round"><path d="M20 6L9 17l-5-5"/></svg>'}
function txt(h){var d=document.createElement('div');d.innerHTML=h;return (d.textContent||'').replace(/\s+/g,' ').trim()}
function rich(h){
  var d=document.createElement('div');d.innerHTML=h;
  d.querySelectorAll('*').forEach(function(n){
    if(!/^(STRONG|EM|B|I)$/.test(n.tagName)) n.replaceWith.apply(n,Array.from(n.childNodes));
  });
  return d.innerHTML.replace(/\s+/g,' ').trim();
}

/* ---- parse the description into sections ---- */
function parse(html){
  var doc=document.createElement('div'); doc.innerHTML=html;
  var nodes=Array.prototype.slice.call(doc.children);
  var intro=[],secs=[],cur=null;
  nodes.forEach(function(n){
    var tag=n.tagName, t=txt(n.innerHTML);
    // a heading is <h2..h4>, or a <p> whose entire content is one <strong> under 90 chars
    var isHead=/^H[234]$/.test(tag) ||
      (tag==='P' && n.children.length===1 && n.children[0].tagName==='STRONG' && t.length<=90 && txt(n.children[0].innerHTML)===t);
    if(isHead){
      var k=canon(t)||t;
      if(cur && cur.k===k) return;
      cur={k:k,items:[],paras:[],ol:false}; secs.push(cur); return;
    }
    if(tag==='UL'||tag==='OL'){
      var li=Array.prototype.slice.call(n.querySelectorAll(':scope > li')).map(function(x){return rich(x.innerHTML)}).filter(Boolean);
      if(!li.length) return;
      if(cur){cur.items=cur.items.concat(li); if(tag==='OL')cur.ol=true}
      return;
    }
    if(tag==='P'){
      var r=rich(n.innerHTML);
      if(txt(r).length<30) return;
      if(cur) cur.paras.push(r); else intro.push(r);
    }
  });
  // merge duplicate canonical sections, drop empties
  var out=[],seen={};
  secs.forEach(function(s){
    if(!s.items.length && !s.paras.length) return;
    if(seen[s.k]!==undefined){var p=out[seen[s.k]];p.items=p.items.concat(s.items);p.paras=p.paras.concat(s.paras);return}
    seen[s.k]=out.length; out.push(s);
  });
  return {intro:intro,secs:out};
}

/* The description is rendered server side (crawlers and no-JS visitors see
   every section). We read it from the DOM, build the tabs, then remove the
   source so nothing appears twice. If no tabs can be built, the source stays
   on the page and the content is never lost. */
var descEl=root.querySelector('[data-desc-source]');
var parsed={intro:[],secs:[]};
try{ parsed=parse(descEl?descEl.innerHTML:'') }
catch(err){ if(window.console) console.error('[pestocart] description parse failed',err) }
var lead=root.querySelector('[data-lead]');
if(lead) lead.innerHTML=parsed.intro[0]||'';

var tabs=root.querySelector('[data-tabs]'), pans=root.querySelector('[data-panels]');
if(tabs&&pans){
  var list=parsed.secs.slice().sort(function(a,b){
    var x=ORDER.indexOf(a.k),y=ORDER.indexOf(b.k);
    return (x<0?99:x)-(y<0?99:y);
  });
  try{
  list.forEach(function(s,i){
    var d=ICON[s.k]||DEF, id='pc-pn-'+i;
    var t=document.createElement('button');
    t.type='button'; t.className='pc-tab'; t.setAttribute('role','tab');
    t.setAttribute('aria-selected', i===0?'true':'false');
    t.setAttribute('aria-controls', id);
    t.innerHTML=svg(d)+'<span>'+s.k+'</span>';
    t.addEventListener('click',function(){
      tabs.querySelectorAll('.pc-tab').forEach(function(x){x.setAttribute('aria-selected','false')});
      pans.querySelectorAll('.pc-panel').forEach(function(x){x.hidden=true});
      t.setAttribute('aria-selected','true');
      document.getElementById(id).hidden=false;
    });
    tabs.appendChild(t);

    var p=document.createElement('div');
    p.className='pc-panel'+(CARE[s.k]?' is-care':'');
    p.id=id; p.hidden=i!==0; p.setAttribute('role','tabpanel');
    var h='<h3><i>'+svg(d,17)+'</i>'+s.k+'</h3>';
    s.paras.forEach(function(x){h+='<p>'+x+'</p>'});
    if(s.items.length){
      var ord=s.ol&&s.k==='How to use';
      h+='<'+(ord?'ol class="pc-stp"':'ul class="pc-bul"')+'>';
      s.items.forEach(function(x){h+='<li>'+(ord?'':tick())+'<span>'+x+'</span></li>'});
      h+=ord?'</ol>':'</ul>';
    }
    p.innerHTML=h; pans.appendChild(p);
  });
  }catch(err){ if(window.console) console.error('[pestocart] tab build failed',err) }

  /* Only hide the server-rendered copy once real panels exist on the page.
     If anything above failed, the full description stays visible. */
  if(pans.children.length && descEl && descEl.parentNode){
    descEl.parentNode.removeChild(descEl);
  } else if(descEl){
    if(lead) lead.innerHTML='';
  }
}

/* ---- gallery: swipeable stage synced with a scrollable thumbnail rail ---- */
var stage=root.querySelector('[data-slides]');
if(stage && stage.children.length){
  var thumbs=Array.prototype.slice.call(root.querySelectorAll('.pc-thumb'));
  var rail=root.querySelector('[data-rail]');
  var gPrev=root.querySelector('.pc-nav--prev'), gNext=root.querySelector('.pc-nav--next');
  var rPrev=root.querySelector('.pc-rail-nav--prev'), rNext=root.querySelector('.pc-rail-nav--next');
  var cnt=root.querySelector('[data-count]');
  var total=stage.children.length;

  var at=function(){return Math.round(stage.scrollLeft/Math.max(1,stage.clientWidth))};
  var go=function(i){
    i=Math.max(0,Math.min(total-1,i));
    stage.scrollTo({left:i*stage.clientWidth,behavior:'smooth'});
  };
  var railEnds=function(){
    if(!rail) return;
    if(rPrev) rPrev.disabled = rail.scrollLeft<=2;
    if(rNext) rNext.disabled = rail.scrollLeft+rail.clientWidth>=rail.scrollWidth-2;
  };
  var sync=function(){
    var i=at();
    thumbs.forEach(function(t,n){t.setAttribute('aria-current', n===i?'true':'false')});
    if(cnt) cnt.textContent=(i+1)+' / '+total;
    if(gPrev) gPrev.disabled = i<=0;
    if(gNext) gNext.disabled = i>=total-1;
    var act=thumbs[i];
    if(act && rail){
      var l=act.offsetLeft, r=l+act.offsetWidth;
      if(l < rail.scrollLeft) rail.scrollTo({left:Math.max(0,l-8),behavior:'smooth'});
      else if(r > rail.scrollLeft+rail.clientWidth) rail.scrollTo({left:r-rail.clientWidth+8,behavior:'smooth'});
    }
  };

  var tmr=null;
  stage.addEventListener('scroll',function(){clearTimeout(tmr);tmr=setTimeout(sync,70)},{passive:true});
  window.addEventListener('resize',function(){clearTimeout(tmr);tmr=setTimeout(sync,140)});

  thumbs.forEach(function(b){
    b.addEventListener('click',function(){go(parseInt(b.dataset.i,10)||0)});
  });
  [gPrev,gNext].forEach(function(b){
    if(b) b.addEventListener('click',function(){go(at()+(parseInt(b.dataset.nav,10)||0))});
  });
  [rPrev,rNext].forEach(function(b){
    if(b && rail) b.addEventListener('click',function(){
      rail.scrollBy({left:(parseInt(b.dataset.railNav,10)||0)*rail.clientWidth*0.8,behavior:'smooth'});
    });
  });
  if(rail) rail.addEventListener('scroll',function(){clearTimeout(tmr);tmr=setTimeout(railEnds,70)},{passive:true});

  stage.addEventListener('keydown',function(e){
    if(e.key==='ArrowRight'){e.preventDefault();go(at()+1)}
    if(e.key==='ArrowLeft'){e.preventDefault();go(at()-1)}
  });

  sync(); railEnds();
}

/* ---- quantity ---- */
var qty=root.querySelector('.pc-qty input');
root.querySelectorAll('.pc-qty [data-q]').forEach(function(b){
  b.addEventListener('click',function(){
    var n=parseInt(qty.value,10)||1;
    qty.value=Math.max(1,n+parseInt(b.dataset.q,10));
  });
});

/* ---- variants ---- */
var vjson=root.querySelector('[data-variants]');
if(vjson){
  var variants=JSON.parse(vjson.textContent);
  var chosen=[];
  root.querySelectorAll('.pc-opt[aria-pressed=true]').forEach(function(b){chosen[+b.dataset.opt]=b.dataset.val});
  var fmt=new Intl.NumberFormat('en-IN',{style:'currency',currency:root.dataset.currency||'INR',minimumFractionDigits:2});
  var PRE=parseFloat(root.dataset.prepaid)||0;

  function paint(){
    var m=variants.find(function(v){return v.o.every(function(o,i){return o===chosen[i]})});
    var hid=root.querySelector('[data-vid]'), atc=root.querySelector('[data-atc]'),
        btn=root.querySelector('.pc-atc');
    if(!m){ if(btn){btn.disabled=true} if(atc){atc.textContent='Unavailable'} return }
    hid.value=m.id; if(btn) btn.disabled=!m.a;
    if(atc) atc.textContent=m.a?(root.dataset.atcText||'Add to cart'):'Sold out';
    var pre=Math.round(m.p*(100-PRE))/100;
    var set=function(sel,val){var e=root.querySelector(sel); if(e) e.textContent=val};
    set('[data-p]',fmt.format(m.p/100));
    set('[data-pre]',fmt.format(pre/100));
    set('[data-ns]',fmt.format(m.p/100));
    set('[data-nu]',fmt.format(pre/100));
    var cs=root.querySelector('[data-c]'), of=root.querySelector('[data-off]'), ne=root.querySelector('[data-ne]');
    if(m.c>m.p){ if(cs){cs.hidden=false;cs.textContent=fmt.format(m.c/100)}
                 if(of){of.hidden=false;of.textContent=Math.round((1-m.p/m.c)*100)+'% OFF'} }
    else { if(cs)cs.hidden=true; if(of)of.hidden=true }
    if(ne) ne.textContent='Save '+fmt.format(((m.c>m.p?m.c:m.p)-pre)/100);
    if(history.replaceState){
      var u=new URL(location.href); u.searchParams.set('variant',m.id); history.replaceState({},'',u);
    }
  }
  root.querySelectorAll('.pc-opt').forEach(function(b){
    b.addEventListener('click',function(){
      var g=+b.dataset.opt; chosen[g]=b.dataset.val;
      root.querySelectorAll('.pc-opt[data-opt="'+g+'"]').forEach(function(x){x.setAttribute('aria-pressed','false')});
      b.setAttribute('aria-pressed','true');
      paint();
    });
  });
}

/* ---- Buy now proxies to Shopify's real dynamic checkout button ---- */
var now=root.querySelector('[data-buynow]');
if(now){
  now.addEventListener('click',function(){
    var real=root.querySelector('.pc-native button, .pc-native .shopify-payment-button__button');
    if(real){ real.click(); return }
    var id=root.querySelector('[data-vid]'), q=qty?qty.value:1;
    if(id) location.href='/cart/'+id.value+':'+q;
  });
}

/* ---- dispatch countdown, derived from a daily cutoff hour ---- */
var cut=root.querySelector('.pc-cut');
if(cut){
  var H=parseInt(cut.dataset.cutoff,10); if(isNaN(H))H=14;
  var clock=function(){
    var now=new Date();
    var ist=new Date(now.getTime()+now.getTimezoneOffset()*60000+5.5*3600000);
    var end=new Date(ist); end.setHours(H,0,0,0);
    var icon='<svg viewBox="0 0 24 24" width="13" height="13" fill="none" stroke="currentColor" stroke-width="2"><circle cx="12" cy="12" r="9"/><path d="M12 7v5l3 2"/></svg> ';
    if(ist.getDay()===0||ist>=end){
      cut.className='pc-cut is-closed';
      cut.innerHTML=icon+'Next dispatch '+(ist.getDay()===6?'Monday':'tomorrow')+' from Indore';
      return;
    }
    var ms=end-ist;
    cut.className='pc-cut';
    cut.innerHTML=icon+'Order within <b>'+Math.floor(ms/3600000)+'h '+Math.floor(ms%3600000/60000)+'m '+Math.floor(ms%60000/1000)+'s</b> for dispatch today';
  };
  clock(); setInterval(clock,1000);
}

/* ---- delivery window, always a range, never one invented date ---- */
var dv=root.querySelector('.pc-deliv');
if(dv){
  var pin=dv.querySelector('[data-pin]'), eta=dv.querySelector('[data-eta]');
  var run=function(){
    var val=(pin.value||'').trim();
    if(!/^\d{6}$/.test(val)){ pin.focus(); return }
    var pre=(dv.dataset.local||'').split(',').map(function(s){return s.trim()}).filter(Boolean);
    var local=pre.some(function(p){return val.indexOf(p)===0});
    var ship=local?dv.dataset.shipLocal:dv.dataset.shipRest;
    var add=function(d){var x=new Date(),c=0;
      while(c<d){x.setDate(x.getDate()+1); if(x.getDay()!==0)c++}
      return x.toLocaleDateString('en-IN',{weekday:'short',day:'numeric',month:'short'})};
    var lo=dv.dataset.min, hi=dv.dataset.max;
    eta.hidden=false;
    eta.innerHTML=
      '<div>'+tick()+'<span>Arrives in <b>'+lo+' to '+hi+' working days</b>, between <b>'+add(+lo)+'</b> and <b>'+add(+hi)+'</b></span></div>'+
      '<div>'+tick()+'<span>Shipping to this pincode: <b>&#8377;'+ship+'</b></span></div>'+
      (dv.dataset.cod?'<div>'+tick()+'<span>Cash on delivery available for <b>&#8377;'+dv.dataset.cod+'</b></span></div>':'');
  };
  dv.querySelector('[data-check]').addEventListener('click',run);
  pin.addEventListener('keydown',function(e){if(e.key==='Enter'){e.preventDefault();run()}});
}
})();